import { NavigationMenuSelection } from "../interfaces/navigation_menu.interface";

export type NavigationSourceSelection = NavigationMenuSelection["sourceSelection"];

export function normalizeNavigationSourceSelection(
    sourceSelection: NavigationSourceSelection | null | undefined
): NavigationSourceSelection {
    const section = typeof sourceSelection?.section === "string" ? sourceSelection.section.trim() : "";
    const target = typeof sourceSelection?.target === "string" ? sourceSelection.target.trim() : "";

    return section && target ? { section, target } : null;
}

export function resolveSourceSelectionTargetKey(
    sourceSelection: NavigationSourceSelection | null | undefined
): string | null {
    return normalizeNavigationSourceSelection(sourceSelection)?.target ?? null;
}
